import { LOANFORMAT_ALL_OBJECT } from '../../shared/loanFormat/constants';

export enum LoanFormatActionType {
    LOAN_FORMAT_CHANGE = 'LOAN_FORMAT_CHANGE'
}

export type LoanFormatState = {
    readonly requestKey: string | null; // e.g. 'EBOOKS',
    readonly key: string; // e.g. 'EBOOKS',
    readonly name: string; // e.g. 'eBooks',
    readonly singularName: string | null; // e.g. 'eBook',
    readonly icon: string; // e.g. 'book',
    readonly urlKey: string; // e.g. 'ebooks'
};

export type LoanFormatActions = LoanFormatChange;

export type LoanFormatChange = {
    type: LoanFormatActionType.LOAN_FORMAT_CHANGE;
    loanFormat: LoanFormatState;
};

export const loanFormatInitialState: LoanFormatState = LOANFORMAT_ALL_OBJECT;

export const loanFormatReducer = (
    state: LoanFormatState = loanFormatInitialState,
    action: LoanFormatActions
): LoanFormatState => {
    switch (action.type) {
        case LoanFormatActionType.LOAN_FORMAT_CHANGE: {
            return {
                ...state,
                ...action.loanFormat
            };
        }
        default:
            return state;
    }
};
